import { Valence } from '../../api/client'
import { VALENCE_OPTIONS } from '../../models/Valence'

// Colour follows what the valence does to moderation: negative classifiers argue for
// hiding comments (severe), positive ones never do (safe), neutral is signal-only and
// stays ink so it recedes. — Claude
const TONES: Record<Valence, { pill: string; dot: string }> = {
    [Valence.Negative]: { pill: 'bg-severe/10 text-severe', dot: 'bg-severe' },
    [Valence.Neutral]: { pill: 'bg-ink-100 text-ink-600', dot: 'bg-ink-400' },
    [Valence.Positive]: { pill: 'bg-safe/10 text-safe', dot: 'bg-safe' }
}

export default function ValencePill({ valence }: { valence: Valence }) {
    const { pill, dot } = TONES[valence]
    const label = VALENCE_OPTIONS.find((o) => o.value === valence)?.label ?? valence
    return (
        <span
            className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ${pill}`}
        >
            <span className={`h-1.5 w-1.5 rounded-full ${dot}`} aria-hidden="true" />
            {label}
        </span>
    )
}
